<template>
	<div 
		class="modal fade" 
		id="changelog-modal" 
		tabindex="-1" 
		data-backdrop="static" 
		aria-labelledby="changelog"
		@keyup.esc="RedirectToHome"
	>
		<div class="modal-dialog">
			<div class="modal-content p-3">
				<div class="modal-header my-3">
					<div class="position-relative">
						<h2 class="text-center">
							Atualização de conteúdo
						</h2>
						<div class="close-modal-button">
							<button
								id="close-modal"
								class="btn btn-light btn-sm m-2"
								@click="CloseModal"
							>
								<i class="fal fa-times"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="modal-body">
					<div class="data-container">
						<div class="version-container">
							<span><b>Versão:</b></span>
							<h6 class="mb-0">{{ notification.version }}</h6>
						</div>
						<div class="date-container">
							<span><b>Data/hora:</b></span>
							<h6 class="mb-0">{{ notification.formmated_date }}</h6>
						</div>
					</div>
					<div class="changelog-container">
						<div id="changelog" v-html="notification.changelog"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ChangelogModal',
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	watch: {
		notification: {
			handler(val) {
				if(val.id) {
					val.formmated_date = window.helpers.ParseDate(val.synced_at)
				}
			},
			immediate: true
		}
	},
	methods: {
		CloseModal() {
			window.jQuery('#changelog-modal').modal('hide')

			this.$emit('close')
		}
	}
}
</script>

<style lang="scss" scoped>
	#changelog-modal {
		.modal-dialog {
			width: 80vw;
			max-width: unset;
			height: 90vh;

			@media (min-width: 1200px) {
				width: 50vw;
				max-width: unset;
			}

			.modal-content {
				height: 100%;

				.modal-header {
					.close-modal-button {
						position: absolute;
						top: -10px;
						right: 0;
					}
				}

				.modal-body {
					margin: 3rem 2rem;
					display: flex;
					flex-direction: column;
					gap: 1rem;

					.data-container {
						display: flex;
						align-items: center;
						justify-content: space-between;

						.version-container,
						.date-container {
							display: flex;
							align-items: center;
							gap: .5rem;
						}
					}

					.changelog-container {
						height: 69vh;
						overflow: auto;
						font-size: 1.5rem;

						border: 1px solid var(--hr);
						padding: 1rem;
						border-radius: .5rem;
					}
				}
			}
		}
	}

	:deep(.changelog-container #changelog ul) {
		margin-left: 1.5em;
		list-style: none !important;
	}

	:deep(.changelog-container #changelog ul li) {
		display: flex;
		align-items: center;

		&::before {
			display: inline-block;
			width: 1.2em;
			content: '\2022';
			font-size: 2.5rem;
			line-height: 1;
		}
	}
</style>